<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.NOTIFICATIONSs.EDIT' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="updateProduct()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-10">

          <!-- ===== Row 1 ===== -->
          <div class="row">
            <!-- User -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-medium">
                {{ 'MENU.DASHBOARD.User_ID' | translate }}
              </label>
              <select
                class="form-control"
                [(ngModel)]="product.user_id"
                name="user_id"
                required
                [compareWith]="compareUsers"
              >
                <option [ngValue]="null" disabled>
                  {{ 'MENU.DASHBOARD.Select_User' | translate }}
                </option>
                <option *ngFor="let user of arrCoupons" [ngValue]="user.id">
                  {{ user.name }}
                </option>
              </select>
            </div>

            <!-- Read -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-medium">
                {{ 'MENU.DASHBOARD.Read' | translate }}
              </label>
              <select
                class="form-control"
                [(ngModel)]="product.read"
                name="read"
              >
                <option [ngValue]="true">
                  {{ 'MENU.DASHBOARD.Read' | translate }}
                </option>
                <option [ngValue]="false">
                  {{ 'MENU.DASHBOARD.Unread' | translate }}
                </option>
              </select>
            </div>
          </div>

          <!-- ===== Row 2 ===== -->
          <div class="row">
            <!-- Title -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-medium">
                {{ 'MENU.DASHBOARD.Title' | translate }}
              </label>
              <input
                type="text"
                class="form-control"
                placeholder="{{ 'MENU.DASHBOARD.Title' | translate }}"
                [(ngModel)]="product.title"
                name="title"
                required
              />
            </div>

            <!-- Message -->
            <div class="col-md-6 mb-3">
              <label class="form-label fw-medium">
                {{ 'MENU.DASHBOARD.Message' | translate }}
              </label>
              <textarea
                class="form-control"
                placeholder="{{ 'MENU.DASHBOARD.Message' | translate }}"
                [(ngModel)]="product.message"
                name="message"
                rows="3"
                required
              ></textarea>
            </div>
          </div>

          <!-- ===== Submit ===== -->
          <div class="d-flex justify-content-end mt-4">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Save_Changes' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div>
</div>
</div>
